import { combineReducers } from 'redux'

import deleteNode from './controls/delete'
import get from './controls/get'
import group from './controls/group'
import list from './controls/list'
import post from './controls/post'
import product from './controls/product'
import put from './controls/put'
import task from './controls/task'
import view from './controls/view'

export default combineReducers({
  delete: deleteNode,
  get,
  group,
  list,
  post,
  product,
  put,
  task,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls.js